export const GTM_STRINGS = {
  CHECKOUT_SUCCESS_PAGE: 'checkout-success-page',
  CART_FLYOUT: 'cart-flyout',
  PRODUCT_DETAIL_PAGE: 'product-detail-page',
  SEARCH_RESULT_LIST: 'search_result_list',
  PRODUCT_LIST: 'product_list',
  PRODUCT_RELATIONS_UPPER_LIST: 'product_relations_upper_list',
  PRODUCT_RELATIONS_SPAREPART_LOWER_LIST: 'product_relations_sparepart_lower_list',
  PRODUCT_RELATIONS_COMPLEMENTARY_LOWER_LIST: 'product_relations_complementary_lower_list',
  PRODUCT_RELATIONS_ACCESSORIES_LOWER_LIST: 'product_relations_accessories_lower_list',
  PRODUCT_VARIANTS_LIST: 'product_variants_list',
  CART_LIST: 'cart_list',
  CART_FLYOUT_LIST: 'cart_flyout_list',
  PRODUCT_CONFIGURATION_RESULT_LIST: 'product_configuration_result_list',
  FAVORITES_FLYOUT_LIST: 'favorites_flyout_list',
  HISTORIC_ORDER_LIST: 'historic_order_list',
  QUICK_ORDER_LIST: 'quick_order_list',
  STICKY_HEADER: 'sticky_header',
  SHOPPING_LIST: 'shopping_list',
  STORES_STOCK_MODAL: 'stores_stock_modal',
  ADD_TO_CART_FROM_FILE_MODAL: 'add_to_cart_from_file_modal',
  REPLACEMENT_PRODUCT: 'replacement_product',
  SELECTED_PRODUCTS_LIST: 'selected_products_list',
  UNKNOWN_LIST: 'unknown_list',
  ABOVE_FOOTER: 'above_footer',
  BANNER_GROUP_POSITION: 'banner_group_position_',
  SEARCH_HISTORY_CONTAINER: 'search_history_container',
  CONFIGURATOR_RESULT_LIST: 'configurator_result_list',
};
